export enum MsSentimentType {
    // on backend - MsSentiment
    none = 0,
    positive = 1,
    neutral = 2,
    negative = 3,
}
